import { render, staticRenderFns } from "./classStudent-list-page.html?vue&type=template&id=1caf9243&"
import script from "./classStudent-list-page.ts?vue&type=script&lang=ts&"
export * from "./classStudent-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./classStudent-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports